<template>
  <v-container class="pwc-self-center" fluid grid-list-lg>
    <v-layout wrap justify-center>
      <v-flex xs10 md4 order-xs2 order-md1>
        <profile
          :info-list="home.cInfoList"
          :avatar="home.userInfo.profilePhotoUrl"
          :upload-avatar="home.handleUpdateAvatar"
          :update="updateProfile"
          :logout="logout"
          :resumes="home.userInfo.resumes || []"
        />
      </v-flex>
      <v-flex xs10 md8 order-xs1 order-md2>
        <wrapper
          :registered-list="home.registeredEvents"
          :prepared-list="home.approvedEvents"
          :go-detail="home.handleGoEventDetail"
        />
      </v-flex>
    </v-layout>
    <pwc-confirm :show.sync="showConfirmDialog" :callback="callback" :message="message" />
    <pwc-update
      :show.sync="showUpdateDialog"
      :age-lookup="home.lookups.ageRange"
      :year-lookup="home.lookups.workYearRange"
      :grade-lookup="home.lookups.anchorStudentGrades"
      :programme-type="home.userInfo.programmeType"
      :info="home.userInfo"
      :update="home.updateUserInfo"
    />
  </v-container>
</template>

<script>
import Profile from './Profile'
import Wrapper from './Wrapper'
import PwcConfirm from '../../PwcConfirm/desktop'
import PwcUpdate from '../../PwcUpdate/desktop'
import { desktopConfirm } from '../../PwcConfirm/mixin/confirm'
import { desktopUpdate } from '../../PwcUpdate/mixin/update'

export default {
  inject: ['home'],
  components: {
    Profile,
    Wrapper,
    PwcConfirm,
    PwcUpdate
  },
  mixins: [desktopConfirm, desktopUpdate],
  methods: {
    logout() {
      this.showConfirm(
        '确认退出登录',
        this.home.handleGoLogout
      )
    },
    updateProfile() {
      if (this.home.userInfo.eventId) {
        this.home.userInfo.eventId = ''
      }
      this.showUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-self-center {
    height: 100%;
    padding: 0;
}
</style>
